module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5QvqE"))).then(() => parcelRequire('1iHdE'));